import cn from "classnames";
import { RoadRouteModel } from "entities/RoadSearchCard";
import { resolveDateValues } from "entities/shared/utils";
import { useTranslation } from "shared/localization/localization";
import { LineRow } from "./LineRow";
import styles from "./LineList.module.scss";

type LineProps = {
  className?: string;
  data: RoadRouteModel;
};

export const Line: RFC<LineProps> = ({ data, className }) => {
  const { t } = useTranslation();
  const { departureDate, arrivalDate } = resolveDateValues({
    atd: data.atd,
    etd: data.etd,
    ata: data.ata,
    eta: data.eta,
    formatedDate: true,
    useValuePlaceholder: true,
    dateFormatOptions: { withTime: true },
  });

  return (
    <div className={cn(styles.line, className)}>
      {data.from?.location && <LineRow title={t("Origin")} value={data.from.location} />}
      {data.to?.location && <LineRow title={t("Destination")} value={data.to.location} />}
      <LineRow title={departureDate.unit} value={departureDate.value} />
      <LineRow title={arrivalDate.unit} value={arrivalDate.value} />
    </div>
  );
};
